export default __webpack_public_path__ + "static/media/05AW1AUG66.c35a61da.jpg";